import React from "react";

import svg from "../../assets/images/icons/attention.svg";

export const AttentionIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Attention"}
    />
);
